import {Component, OnInit} from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, ParamMap } from '@angular/router';
import {GoogleTagManagerService} from './services/google-tag-manager.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';
  params = null;
  segments = null;
  data = null;
  parentUrl = null;
  parentParams = null;

  ngOnInit() {
    this.router.events.subscribe((event: any) => {
      let r = this.activatedRoute;
      while (r.firstChild) {
        r = r.firstChild;
      }
      r.params.subscribe(params => {
        this.params = params;
      });
      r.url.subscribe(url => {
        this.segments = url;
      });
      r.data.subscribe(data => {
        this.data = data;
      });
      if (r.parent) {
        r.parent.url.subscribe(url => {
          this.parentUrl = url;
        });
        r.parent.params.subscribe(params => {
          this.parentParams = params;
        });
      }
    });
  }

  constructor(
    private router: Router,
    private gtmService: GoogleTagManagerService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.router.events.forEach(item => {
      if (item instanceof NavigationEnd && !item.url.includes('/admin')) {
        const gtmData = {
          data: this.data,
          url: item.url,
          segments: this.segments,
          params: this.params,
          parentUrl: this.parentUrl,
          parentParams: this.parentParams,
        };
        this.gtmService.pushPageView(gtmData);
      }
    });
  }
}
